<template>
<div>
    <div class="col">
        <div class="ibox sombra-light">
            <div class="ibox-title">
                <h5>
                    Lista Negra
                </h5>
                <div class="ibox-tools">
                    <button class="btn-primary" @click="agregar">Agregar</button>
                </div>
            </div>
            <div class="ibox-content">
                <data-table :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12">
                    <template v-slot:opciones="item">
                        <div class="dropdown float-right">
                            <button class="btn btn-gray btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Opciones
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a href="javascript:void(0)" @click="editar(item.data)">
                                        <i class="fal fa-edit"></i> Editar
                                    </a>
                                    <a href="javascript:void(0)" @click="eliminar(item.data.id)">
                                        <i class="fal fa-trash-alt"></i> Eliminar
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </template>
                </data-table>
            </div>
        </div>
    </div>
    <Modal ref="Modal" :tipo="tipo" @accion="accion" :nombre="data.bloqueado"></Modal>
    <ModalDelete ref="ModalDelete" @eliminar="borrar"></ModalDelete>

</div>
</template>

<script>
import axios from 'axios';
import DataTable from '../../DataTableLuis.vue';
import Modal from './agregar_editar_modal.vue';
import ModalDelete from './delete.vue';

export default {
    props: ['lista'],
    components: { DataTable, Modal, ModalDelete },
    data() {
        return {
            dt: {
                id: 'lista-negra',
                columnas: [
                    { nombre: 'Id', nombre_variable: 'id' },
                    { nombre: 'Email/Dominio', nombre_variable: 'bloqueado' },
                    { nombre: 'Opciones', nombre_variable: 'opciones', slot: 1 },
                ],
                datos: []
            },
            tipo: "Agregar",
            data: {
                bloqueado: ""
            }
        }
    },
    mounted() {
        this.dt.datos = this.lista
    },
    methods: {
        agregar() {
            this.tipo = "Agregar"
            this.data = {
                bloqueado: ""
            }
            this.$refs.Modal.show()
        },
        editar(data) {
            this.tipo = "Editar"
            this.data = data
            this.$refs.Modal.show()
        },
        accion(nombre) {
            console.log(nombre);

            if (this.tipo == "Agregar") {
                axios.post('', { bloqueado: nombre }).then(response => {
                    this.lista.push(response.data)
                    this.dt.datos = []
                    setTimeout(() => {
                        this.dt.datos = this.lista
                    }, 500);
                }).catch(error => {
                    console.log(error);
                })
            } else {
                axios.patch('lista-negra/' + this.data.id, { bloqueado: nombre }).then(response => {
                    let bloqueado = this.lista.findIndex(element => {
                        return element.id == this.data.id
                    })
                    this.lista[bloqueado].bloqueado = nombre
                    this.dt.datos = []
                    setTimeout(() => {
                        this.dt.datos = this.lista
                    }, 500);
                }).catch(error => {
                    console.log(error);
                })
            }
        },
        eliminar(id) {
            this.data.id = id;
            this.$refs.ModalDelete.show()
        },
        borrar() {
            axios.delete('lista-negra/' + this.data.id).then(response => {
                let bloqueado = this.lista.findIndex(element => {
                    return element.id == this.data.id
                })
                this.lista.splice(bloqueado, 1);
                this.dt.datos = []
                setTimeout(() => {
                    this.dt.datos = this.lista
                }, 500);
            }).catch(error => {
                console.log(error);
            })
        }
    },
}
</script>
